import { memo } from "react";

import { Text } from "@components/Text";
import { Video } from "@components/Video";
import { Slide } from "@react/components/Carousel";
import { type TTailwindString, tw } from "classnames";

type Props = {
  handleModalButtonClick: () => void;
  text: {
    playVideoModal: string;
  };
  video: {
    posterImage?: string;
    sources: { mimeType: string; url: string }[];
    subtitles?: string;
    title: string;
  };
};

const styles = {
  slide: tw("transition-opacity"),
  modalButton: tw(
    "relative",
    "block",
    "h-[180px]" as TTailwindString,
    "w-[110px]" as TTailwindString,
    "overflow-hidden",
    "rounded-lg",
    "md:h-[195px]" as TTailwindString,
    "md:w-30",
    "border-0",
    "outline-none",
    "p-0"
  ),
  videoTitle: tw(
    "absolute",
    "bottom-1.5",
    "left-1.5",
    "text-left",
    "text-white",
    "md:bottom-[7px]" as TTailwindString,
    "md:left-[7px]" as TTailwindString
  ),
};

const UGCVideoCarouselSlideViewBase = ({
  handleModalButtonClick,
  text,
  video,
}: Props) => {
  return (
    <Slide className={styles.slide} key={video.title}>
      <button
        aria-label={text.playVideoModal}
        className={styles.modalButton}
        onClick={handleModalButtonClick}
        type="button"
      >
        <Video
          cover
          height={195}
          muted
          playsInline
          poster={video.posterImage}
          sources={video.sources}
          width={120}
        />
        <div className={styles.videoTitle}>
          <Text as="body2">{video.title}</Text>
        </div>
      </button>
    </Slide>
  );
};

export const UGCVideoCarouselSlideView = memo(UGCVideoCarouselSlideViewBase);
